import React, { forwardRef } from "react";
import classnames from "classnames";

import { Icon, IconName, IconSize } from "@formant/ui/component/common/Icon";

import { Button, ButtonProps } from "./Button";
import styles from "./IconButton.module.scss";

export interface IIconButtonProps extends ButtonProps {
    icon: IconName;
    size?: IconSize;
}

export const IconButton = forwardRef<
    HTMLButtonElement & HTMLAnchorElement,
    IIconButtonProps
>(function IconButton(props, ref) {
    const { icon, className, children, size, ...rest } = props;
    return (
        <Button
            ref={ref}
            className={classnames(styles["icon-button"], className)}
            {...rest}
        >
            <Icon color="var(--color-text-primary)" name={icon} size={size} />
            {children}
        </Button>
    );
});
